import React from "react";
import { VideoPlayer } from "components/steps/RecordVideo/VideoPlayer";
import { useVideoPlayer } from "hooks/useVideoPlayer";

interface ProfileCardHeaderProps {
  videoSrc: string;
}

const ProfileCardHeader: React.FC<ProfileCardHeaderProps> = ({ videoSrc }) => {
  const { isMuted, isPlaying, videoRef, toggleMute, togglePlay } =
    useVideoPlayer();

  return (
    <VideoPlayer
      videoSrc={videoSrc}
      isMuted={isMuted}
      isPlaying={isPlaying}
      videoRef={videoRef}
      onToggleMute={toggleMute}
      onTogglePlay={togglePlay}
      videoClassName="rounded-tr-[16px] rounded-tl-[16px]"
    />
  );
};

export default ProfileCardHeader;
